<script setup lang="ts">
import BlogCommentAsync from "@/components/blog/BlogComment.vue";
const { $fetchApi, $axios }: any = useNuxtApp();

const blog = ref<any>({});
const router = useRouter();
const tags = ref<any>({});
const comments = ref<any>([]);
const err = ref(false);

const getBlogByID = async () => {
  try {
    const { status, data } = await $fetchApi(
      `/cms/blog/show/${useRoute().params.id}`
    );
    if (status) {
      blog.value = data;
      tags.value = blog.value.tag.join(", ");
      await getBlogCommentByID();
    } else {
      err.value = true;
    }
  } catch (error) {
    console.error("Error fetching blog detail:", error);
  }
};

const getBlogCommentByID = async () => {
  try {
    const { status, data } = await $axios(`/blog-comment/${blog.value.id}`);
    if (status) comments.value = data;
  } catch (error) {
    console.error("Error fetching comments:", error);
  }
};

await getBlogByID();

const nextBlog = (type: string) => {
  if (type == "prev" && blog.value.prev) router.push(blog.value.prev);
  if (type == "next" && blog.value.next) router.push(blog.value.next);
};

if (blog.value) {
  useSeoMeta({
    title: `${blog.value.title} - Bali Bikes Island`,
    ogTitle: `${blog.value.title} - Bali Bikes Island`,
    description: `${blog.value.meta_description} ${tags.value}`,
    ogDescription: `${blog.value.meta_description} ${tags.value}`,
    ogImage: `${blog.value.images}`,
  });
}
</script>

<template>
  <div class="pt-24 bg-white">
    <div class="container">
      <div v-if="err" class="flex flex-col sm:flex-row gap-8 pb-12 pt-6">
        No data found
      </div>
      <div v-else class="flex flex-col sm:flex-row gap-8 pb-12 pt-6">
        <section class="max-w-3xl mx-auto">
          <h1 class="font-bold text-3xl text-primary">{{ blog.title }}</h1>
          <div class="my-4 border-t border-gray-300"></div>

          <div class="flex items-center text-sm gap-2">
            <span class="flex items-center gap-2"
              ><MazAvatar src="/favicon.ico" size="8px" />
              By Bali Bikes Island
            </span>
            <Icon name="mdi:circle-small" />
            <div class="text-neutral-600 text-base">
              {{ blog.created_at }}
            </div>
            <!-- <Icon name="mdi:circle-small" /> -->
          </div>

          <section class="mt-4 blog-wrapper">
            <MazLazyImg :src="blog.images" />
            <div class="ql-editor">
              <div v-html="blog.description" class="text-justify mt-4"></div>
            </div>
          </section>

          <section class="flex flex-wrap gap-2 my-6">
            <span class="text-xl">Tags</span>:
            <span
              v-for="tag in tags.split(', ')"
              class="px-2 py-1 rounded-xl text-sm border border-gray-400"
            >
              {{ tag }}
            </span>
          </section>

          <section class="mb-6">
            <div class="my-4 border-t border-gray-300"></div>
            <div class="flex justify-between text-sm">
              <MazBtn
                :disabled="!blog.prev"
                variant="link"
                class="flex items-center gap-2"
                @click="nextBlog('prev')"
              >
                <Icon
                  name="mdi:arrow-left"
                  :class="!blog.prev && 'text-slate-400'"
                />
                <span :class="!blog.prev && 'text-slate-400'"> Prev </span>
              </MazBtn>

              <MazBtn
                :disabled="!blog.next"
                variant="link"
                class="flex items-center gap-2"
                @click="nextBlog('next')"
              >
                <span :class="!blog.next && 'text-slate-400'"> Next </span>
                <Icon
                  name="mdi:arrow-right"
                  :class="!blog.next && 'text-slate-400'"
                />
              </MazBtn>
            </div>
            <div class="my-4 border-t border-gray-300"></div>
          </section>
          <ClientOnly>
            <BlogCommentAsync
              :comments="comments"
              :blog="blog"
              @getCommentById="getBlogCommentByID"
            />
          </ClientOnly>
        </section>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.blog-wrapper {
  h2 {
    font-size: 24px !important;
    font-weight: bold !important;
    margin-bottom: 10px;
  }

  h3 {
    font-size: 18px !important;
    font-weight: bold !important;
    margin-bottom: 10px;
  }
}
</style>
